import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'id', label: 'ID' },
  { id: 'name', label: 'Nom' },
  { id: 'vendor', label: 'Vendeur' },
  { id: 'toDoQuantity', label: 'À préparer' },
  { id: 'toShipQuantity', label: 'Préparées, à expédier' },
  { id: 'shippedQuantity', label: 'Expédiées' },
  { id: 'total', label: 'Total' }
];

/**
 * Entête du tableau dans la section de receptions
 */
const EnhancedTableHead = () => (
  <TableHead>
    <TableRow>
      {rows.map(
        row => (
          <TableCell key={row.id} align="left" style={{ fontWeight: 'bold' }}>
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

export default EnhancedTableHead;
